export default __webpack_public_path__ + "static/media/art-0-membrane.6ab00d12.jpeg";